export default __webpack_public_path__ + "static/media/sidebar-orange-dark@2x.4994b69b.png";